import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { RelatedInfluencer } from '../../../../../models/influencer/related-influencer';

@Component({
    selector: 'related-influencers',
    templateUrl: './related-influencers.component.html',
    styleUrls: ['./related-influencers.component.scss']
})
export class RelatedInfluencersComponent implements OnChanges {
    public drawnRelatedInfluencers: RelatedInfluencer[] = [];
    public hasNoData = true;
    public placeholderIndicies = Array.from(Array(5).keys());

    @Input() relatedInfluencers: RelatedInfluencer[];
    @Input() isFetchingData: boolean;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.relatedInfluencers) {
            this.updateDrawnRelatedInfluencers(changes.relatedInfluencers.currentValue);
        }
    }

    private updateDrawnRelatedInfluencers(relatedInfluencers: RelatedInfluencer) {
        if (!Array.isArray(relatedInfluencers) || relatedInfluencers.length === 0) {
            this.hasNoData = true;
            return;
        }

        this.drawnRelatedInfluencers = relatedInfluencers.slice(0, 5);
        this.hasNoData = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/related-influencers/related-influencers.component.ts